<template>
  <div id="registration">
    <div class="top">
      <div class="line" v-for="(item, index) in searchData" :key="index">
        <el-input v-model="item.value" v-if="item.type == 'input'" :placeholder="'请输入' + item.title" clearable
          @change="initTableData"></el-input>
        <el-select v-model="item.value" :placeholder="'请选择' + item.title" v-if="item.type == 'select'"
          @change="initTableData" clearable>
          <el-option v-for="it in item.options" :key="it.value" :label="it.label" :value="it.value">
          </el-option>
        </el-select>
        <el-date-picker v-model="item.value" v-if="item.type == 'time_year'" type="year" clearable placeholder="选择年"
          @change="initTableData" value-format="yyyy">
        </el-date-picker>
      </div>
      <div class="perch-active"></div>
      <div class="but" v-for="(item, index) in butData" :key="'but' + index">
        <el-upload v-if="item.active == 'export'" class="upload-demo" :action="action + item.url" :headers="headers"
          :show-file-list="false" multiple :data="{
            title: item.uploadTitle,
            project: '新华学院',
          }" :before-upload="(file) => {
            return beforeAvatarUpload(file, item);
          }
            " :on-success="handleAvatarSuccess" :on-error="handleAvatarError">
          <div class="bb"><i :class="item.icon"></i> {{ item.title }}</div>
        </el-upload>

        <div class="bb" @click="clickBut(item)" v-else>
          <i :class="item.icon"></i> {{ item.title }}
        </div>
      </div>
    </div>
    <div class="content">
      <div class="tabs">
        <div :class="{ tab: true, active: item.flag == flag }" v-for="(item, index) in tabList" :key="index"
          @click="changeTab(item.flag)">
          {{ item.title }}
        </div>
      </div>
      <el-table v-loading="loading" ref="singleTable" :data="tableData" highlight-current-row style="width: 99%"
        height="90%" :header-cell-style="{
          background: ' rgba(240, 240, 240, 1)',
          color: '#000000',
        }">
        <el-table-column width="55" type="index"> </el-table-column>
        <template><el-table-column v-for="(item, index) in tableMenu" :property="item.key" :key="index"
            :label="item.title" :width="item.width" show-overflow-tooltip style="background-color: #eee">
          </el-table-column>
        </template>
      </el-table>
    </div>
    <div class="page">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="pageData.currentPage" :page-sizes="[20, 30, 50, 100]" :page-size="pageData.pageSize"
        layout="total,sizes, prev, pager, next,jumper" :total="pageData.total">
      </el-pagination>
    </div>

    <diy_dialog v-if="dialogData.flag" :title="dialogData.title" :dialogData="dialogData.data"
      :buttonArray="dialogData.buttonArray" @butClick="butClick" @cancelDialog="cancelDialog"></diy_dialog>
  </div>
</template>

<script>
import * as registrationData from "./registration.js";
export default {
  data() {
    return {
      flag: 0,
      loading: false,
      searchData: registrationData.returnSearchData([]),
      butData: registrationData.returnButData(0),
      tabList: [
        { title: "报名信息", flag: 0 },
        { title: "准考证信息", flag: 3 },
        { title: "成绩信息", flag: 1 },
        { title: "录取信息", flag: 2 },
        { title: "普本录取", flag: 8 },
      ],
      tableData: [],
      tableMenu: registrationData.returnMenu(0),
      pageData: {
        currentPage: 1,
        pageSize: 20,
        total: 0,
      },
      headers: {
        token: this.$token,
      },
      action: this.$baseurl + registrationData.returnInitUrl(3),

      dialogData: {
        flag: false,
        tempId: "", // 用于临时存储相关ID
        title: "密码修改",
        buttonArray: [
          { name: "确认", active: "sureEditPsw", type: "primary" },
          { name: "取消", active: "cancel", type: "info" },
        ],
        data: [
          { title: "原密码", type: "pwd", value: "", key: "old" },
          { title: "新密码", type: "pwd", value: "", key: "newPwd" },
          { title: "再次输入密码", type: "pwd", value: "", key: "newPwdTwo" },
        ],
      },
    };
  },
  methods: {
    /**
     * 初始化搜索数据
     */
    getLabelList() {
      this.$request(
        "post",
        "/label/getLabelList",
        { type: "profession" },
        (data) => {
          console.log("//查看审核不通过原因", data);
          let arr = [];
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            let obj = {
              label: element.content,
              value: element.content,
            };
            arr.push(obj);
          }
          this.searchData = registrationData.returnSearchData(arr);
          this.changeTab(0);
        }
      );
    },
    /**
     * 初始化表格数据
     */
    initTableData() {
      this.loading = true;
      let requestData = {
        currentPage: this.pageData.currentPage,
        pageSize: this.pageData.pageSize,
      };
      this.searchData.forEach((element) => {
        this.$set(requestData, element.key, element.value);
      });
      this.$request(
        "post",
        registrationData.returnInitUrl(this.flag),
        requestData,
        (data) => {
          this.pageData.total = data.total;
          this.tableData = data.tableData;
          this.loading = false;
        }
      );
      setTimeout(() => {
        this.loading = false;
      }, 300);
    },
    /**
     * 切换tab标签
     */
    changeTab(flag) {
      this.flag = flag;
      this.butData = registrationData.returnButData(flag);
      this.tableMenu = registrationData.returnMenu(flag);
      this.action = this.$baseurl
      //  + registrationData.returnInitUrl(flag + 4);
      this.initTableData();
    },
    /**
     * 界面的按钮操作
     */
    clickBut(item) {
      switch (item.active) {
        case "clean":
          // 清空教务处报名信息
          this.$prompt(
            "此操作将会清空本年度的所有信息,包括成绩和录取,请输入“确认删除”以确认:",
            "提示",
            {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
            }
          )
            .then(({ value }) => {
              if (value == "确认删除") {
                this.$request("post", "/registration/clearTrue", {}, (data) => {
                  this.$message({
                    type: "success",
                    message: "本年度录取信息已清空,请重新导入信息!",
                  });
                  this.initTableData();
                });
              } else {
                this.$message({
                  type: "error",
                  message: "校验码错误,请重新输入!",
                });
              }
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "取消输入",
              });
            });
          break;
        case "chooseExport":
          // 导入前的选择
          this.openDialog(item)
          break
        case "model":
          // 导入信息
          let type =
            this.flag == 0
              ? "trueModel"
              : this.flag == 1
                ? "scoreModel"
                : this.flag == 2
                  ? "enrollModel"
                  : "admitModel";
          window.open(this.$baseurl + "/downloadModel?type=" + type);
          break;

        default:
          break;
      }
    },
    openDialog(data) {
      switch (data.uploadTitle) {
        case "导入教务处信息":
        case "导入录取信息":
          this.dialogData.title = "选择导入方式"
          this.dialogData.data = [
            {
              title: "导入方式", type: "select-tips", value: "over", key: "exportWay", options: [
                { id: "over", name: "直接覆盖", tip: "清空本年度录取信息同时,导入新的录取数据!" },
                { id: "add", name: "数据叠加", tip: "保留本年度数据的同时,导入新的录取数据,新旧数据已学生的身份证号为唯一标识!" },
              ]
            },
          ];
          this.dialogData.buttonArray = [
            {
              name: "开始导入", active: "export", url: data.url, action: this.$baseurl, data: {
                title: data.uploadTitle
              }
            },
            { name: "取消", active: "cancel", type: "info" },
          ]
          this.dialogData.width = "500px";
          this.dialogData.flag = true;
          break;

        default:
          break;
      }
    },
    /**
     * 导入前文件格式判断  只能上传exel格式数据
     */
    beforeAvatarUpload(file, item) {
      console.log(file.type);
      let type = true;
      if (item.uploadTitle != "导入照片") {
        type =
          file.type ==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
          file.type == "application/vnd.ms-excel";
        if (!type) {
          this.$message.error("上传文件只能是 excel 文件!");
        }
      } else {
        type = file.type == 'application/x-zip-compressed'
        if (!type) {
          this.$message.error("请上传zip文件!");
        }
      }

      return type;
    },
    handleAvatarSuccess(response, file, fileList) {
      console.log(response);
      if (response.code != 200) {
        this.$message.error(response.msg);
        return;
      }
      this.$message.success(response.result);
      this.initTableData();
    },
    /**
     *
     */
    handleAvatarError(err, file, fileList) {
      console.log(err);
      // this.$message.error("文件上传失败,请检查网络!");
    },
    /**
     * 页码选择器改变事件
     * val:每页条数
     */
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageData.pageSize = val;
      this.initTableData();
    },
    /**
     * 选择页码事件
     * val:当前页
     */
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.initTableData();
    },
    butClick(active) {
      switch (active) {
        case "cancel":
          this.cancelDialog();
          break;
        case "uploadSuccess":
          this.initTableData();
          this.cancelDialog();
          break
      }
    },
    cancelDialog() {
      this.dialogData.flag = false;
    },

  },
  mounted() {
    this.getLabelList();
  },
};
</script>

<style lang="less" scoped>
#registration {
  width: 100%;
  height: 100%;
  background-color: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  >.top {
    width: 100%;
    height: 55px;
    min-height: 55px;
    display: flex;
    padding: 0 10px;
    box-sizing: border-box;
    align-items: center;

    >.line {
      width: 220px;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-right: 8px;
    }

    >.but {
      width: auto;
      height: auto;
      padding: 3px 12px;
      font-size: 14px;
      color: #fff;
      background-color: #0076fc;
      margin: 0 8px;
      border-radius: 5px;
      box-sizing: border-box;
      cursor: pointer;

      i {
        margin-right: 5px;
      }

      .bb {
        width: 100%;
        height: 100%;
      }
    }
  }

  >.content {
    width: 100%;
    height: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;

    >.tabs {
      width: 100%;
      height: 40px;
      min-height: 40px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #e7e7e7;
      padding-left: 20px;
      box-sizing: border-box;
      margin-bottom: 5px;

      >.tab {
        width: auto;
        height: 100%;
        padding: 0 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        cursor: pointer;
        font-weight: 600;
        font-size: 15px;
        border-bottom: 2px solid #33333300;
      }

      >.active {
        border-color: #0076fc;
        color: #0076fc;
      }
    }
  }

  >.page {
    width: 100%;
    height: 55px;
    min-height: 55px;
    display: flex;
    align-items: center;
  }
}
</style>